import validator from "../validators/validator";
import Content from "../components/ManageServiceContent";
import { IWizardStep } from "../../../wizard/types";

export const editConfig: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Edit service",
  },
  content: Content,
  validator: validator,
};
